import React from 'react';
import { ConfirmationDelete } from 'components/Dialogs';

const MESSAGE = '';
const DeleteCalibrationDialog = () => <ConfirmationDelete itemName="calibration" customMessage={MESSAGE} />;

export default DeleteCalibrationDialog;
